import React from 'react';
import { Check } from 'lucide-react';
import Background from '../components/Background';

export default function Terms() {
  const terms = [
    'Our service is free of charge.',
    'We are not responsible if your account is banned for rule violations.',
    'You are responsible for your own actions.',
    'We have no obligation to support minor or personal issues.',
    'By using this service, you agree to these terms.'
  ];

  return (
    <>
      <Background />
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-fuchsia-600">
              Terms of Service
            </h1>
            <p className="text-xl text-gray-300 font-light">
              Please read our terms carefully
            </p>
          </div>

          <div className="relative">
            <div className="relative bg-black/40 backdrop-blur-xl rounded-3xl p-12 border border-purple-500/20">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gradient-to-r from-purple-600 to-fuchsia-600 px-8 py-3 rounded-full text-white">
                <span className="font-medium">Important Notice</span>
              </div>
              
              <ul className="space-y-6">
                {terms.map((term, index) => (
                  <li 
                    key={index} 
                    className="flex items-start group animate-fadeIn"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="mr-4 p-2 rounded-lg bg-gradient-to-br from-purple-500/10 to-fuchsia-500/10 group-hover:from-purple-500/20 group-hover:to-fuchsia-500/20 transition-all duration-300">
                      <Check className="w-5 h-5 text-purple-400" />
                    </div>
                    <p className="flex-1 text-lg text-gray-300 group-hover:text-purple-300 transition-colors duration-300">
                      {term}
                    </p>
                  </li>
                ))}
              </ul>

              <div className="mt-12 pt-8 border-t border-purple-500/10">
                <p className="text-gray-400 text-center">
                  By continuing to use our service, you acknowledge that you have read and agree to these terms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}